import { Component, Input } from '@angular/core';
import { GeneralLiabilityResponse } from '../../../../../models/api/view/claim/details/general-liability/general-liability-response';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-professional-liability',
  imports: [DetailPanelComponent, DetailItemComponent, CardComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
      <app-card label="Injured/Owner" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.professionalLiability">
          <app-detail-item label="File type" name="fileType" />
          <app-detail-item label="Action status" name="actionStatus" />
          <app-detail-item label="Matter type" name="matterType" />
          <app-detail-item label="Injured party type" name="injuredPartyType" />
          <app-detail-item label="Department" name="department" />
          <app-detail-item label="Notice mode" name="noticeMode" />
          <app-detail-item label="Claim disposition" name="claimDisposition" />
          <app-detail-item label="Action date" name="actionDate" format="d" />
        </app-detail-panel>
      </app-card>
      <app-card label="Treatment" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.treatment">
          <app-detail-item label="Procedure group" name="procedureGroup" />
          <app-detail-item label="Procedure" name="procedure" />
          <app-detail-item
            label="Medical record number"
            name="medicalRecordNumber"
          />
        </app-detail-panel>
      </app-card>
      <app-card label="Sequelae" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.sequelae">
          <app-detail-item label="Sequelae group" name="sequelaeGroup" />
          <app-detail-item label="Sequelae" name="sequelae" />
        </app-detail-panel>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class ProfessionalLiabilityComponent extends BaseComponent {
  @Input() dataSource: GeneralLiabilityResponse;
  @Input() showMMFields = false;
}
